<!-- Atlas Navigation Bar -->
<ng-container *ngIf="{ partnerId: partnerId$ | async } as data">
  <atlas-navbar [dropdownItems]="atlasMenuItems" [partnerId]="data.partnerId" [serviceProviderId]="'vendor-center'">
    <div class="atlas-navbar-space">
      <atlas-item interactable icon="menu" (click)="toggle()"></atlas-item>
      <div class="atlas-title">
        <atlas-title icon="location_city" interactable="{{ isSuperAdmin$ | async }}" (click)="showPidSelector()">
          {{ atlasTitle$ | async }}
        </atlas-title>
      </div>
      <div class="atlas-spacer"></div>
      <div class="atlas-actions">
        <inbox-button *ngIf="inboxEnabled$ | async"></inbox-button>
      </div>
    </div>
  </atlas-navbar>
  <inbox-inbox>
    <!-- Navigation Menu -->
    <glxy-nav [appName]="'vendor-center'" class="glxy-nav--platform-light-theme">
      <glxy-nav-panel>
        <!-- Header -->
        <glxy-nav-header class="header-content">
          <div class="logo">
            <img src="{{ whitelabelLogoUrl$ | async }}" />
          </div>
          <span class="name">Vendor Center</span>
        </glxy-nav-header>

        <!-- Navigation Items-->
        <glxy-nav-item icon="apps" route="/products">Products</glxy-nav-item>
        <div *ngIf="crmFeatureFlags$ | async as featureFlags">
          <glxy-nav-item *ngIf="featureFlags[FeatureFlags.CRM_COMPANY_TAB]" icon="location_city" route="/crm/company">
            Companies
          </glxy-nav-item>
          <glxy-nav-item *ngIf="featureFlags[FeatureFlags.CRM_TAB]" icon="person" route="/crm/contact">
            Contacts
          </glxy-nav-item>
        </div>

        <glxy-nav-item *ngIf="isVendorDistributed$ | async" icon="people" route="/resellers">Resellers</glxy-nav-item>
        <glxy-nav-item icon="domain" route="/accounts">Accounts</glxy-nav-item>

        @if (singleOrdersTableFeatureFlag$ | async) {
          <glxy-nav-item icon="list_alt" route="/work-orders">Work Orders</glxy-nav-item>
        } @else {
          <glxy-nav-item-list icon="list_alt" [startExpanded]="isOrdersPage">
            Orders
            <glxy-nav-item-list-items>
              <glxy-nav-item route="/orders">Sales orders</glxy-nav-item>
              <glxy-nav-item route="/work-orders">Work orders</glxy-nav-item>
            </glxy-nav-item-list-items>
          </glxy-nav-item-list>
        }

        <!-- Navigation Items Footer-->
        <glxy-nav-footer>
          <glxy-nav-item
            icon="description"
            href="https://developers.vendasta.com/vendors/getting-started"
            target="_blank"
          >
            Documentation
          </glxy-nav-item>
        </glxy-nav-footer>
      </glxy-nav-panel>

      <app-page-content></app-page-content>
    </glxy-nav>
  </inbox-inbox>
</ng-container>
